module.exports = __webpack_public_path__ + "static/media/IVR.b998ad29.png";